import React from "react";
import {
  Box,
  Button,
  Card,
  CardBody,
  Image,
  Text,
  VStack,
} from "@chakra-ui/react";
const ProfilePage = () => {
  return (
    <Box>
      <Text>Profile Page</Text>
    </Box>
  );
};

export default ProfilePage;
